import Socket from '~/plugins/signalr'

export default {
  namespaced: true,
  state: {
  },
  actions: {
    broadcastItemNotExist({ dispatch, commit, state, rootGetters }, data) {
      Socket.invoke('BroadcastItemNotExist', data.form, data.code, data.additionalBroadcastFields || {}, rootGetters['useraccount/currentUserDetails'].fiscalId)
        .then(response => { }).catch(err => { console.log('BroadcastItemNotExist error:', err) })
    },
    broadcastItemExist({ dispatch, commit, state, rootGetters }, data) {
      return Socket.invoke('BroadcastItemExist', data.form, data.code, data.additionalBroadcastFields || {}, rootGetters['useraccount/currentUserDetails'].fiscalId)
        .catch(err => { console.log('BroadcastItemExist error:', err) })
    },
    broadcastRefresh({ dispatch, commit, state, rootGetters }, type) {
      Socket.invoke('BroadcastRefresh', type, rootGetters['useraccount/currentUserDetails'].fiscalId)
        .then(response => { }).catch(err => { console.log('BroadcastRefresh error:', err) })
    }
  }
}
